import React from 'react';
import {observer} from 'mobx-react';
import FormSection from '../../forms/FormSection';
import FormRow from '../../forms/FormRow';
import FormColumn from '../../forms/FormColumn';
import FormTextField from '../fields/FormTextField';
import FormAutocompleteField from '../fields/FormAutocompleteField';
import FormAutocompleteMultipleSelectField from "../fields/FormAutocompleteMultipleSelectField";
import FormGooglePlacesAutocompleteField from '../fields/FormGooglePlacesAutocompleteField';
import Typography from "@mui/material/Typography";
import GoogleAddressMap from '../maps/GoogleAddressMap';
import { Grid } from "@mui/material";
import useFeature from '../../useFeature';
import GoogleAddressMapFeature from '../maps/GoogleAddressMapFeature';

function DeliverySiteOnboardingRequestFormScreen({
    deliverySite, 
    jurisdictionsOptions,
    zonesOptions, 
    frequenciesOptions,
    zonesFrequencyForDeliverySite,
}) {
    const zonesFrequency = zonesFrequencyForDeliverySite(deliverySite);
    const zonesFrequencyString = zonesFrequency && zonesFrequency.length > 0 ? zonesFrequency.join(' - ') : '';
    
    const mapFeature = useFeature(() => new GoogleAddressMapFeature(
        deliverySite,
        'address',
        'jurisdiction',
        'city',
        'postalCode',
        jurisdictionsOptions
    ), [deliverySite]);

    const handlePlaceSelected = (placeData) => {
        mapFeature.updateFromPlaceSelection(placeData);
    };

    return (
        <FormSection>
            <FormColumn>
                <FormRow>
                    <FormTextField
                        label="Nombre del Punto de Entrega"
                        form={deliverySite}
                        fieldName="name"
                    />
                    <FormGooglePlacesAutocompleteField
                        label="Domicilio"
                        form={deliverySite}
                        fieldName="address"
                        onPlaceSelected={handlePlaceSelected}
                        isGoogleMapsLoaded={mapFeature?.isGoogleMapsLoaded || false}
                    />
                    <FormAutocompleteField
                        label="Provincia"
                        form={deliverySite}
                        fieldName="jurisdiction"
                        options={jurisdictionsOptions}
                        readOnly={mapFeature?.jurisdictionWasAutocompleted || false}
                    />
                </FormRow>

                <FormRow>
                    <FormTextField
                        label="Localidad"
                        form={deliverySite}
                        fieldName="city"
                        disabled={mapFeature?.cityWasAutocompleted || false}
                    />
                    <FormTextField
                        label="Código Postal"
                        form={deliverySite}
                        fieldName="postalCode"
                        disabled={mapFeature?.postalCodeWasAutocompleted || false}
                    />
                    <FormTextField
                        label="Horario de Preferencia"
                        form={deliverySite}
                        fieldName="preferredDeliveryTimeRange"
                    />
                </FormRow>
                <FormRow>
                    <Grid item xs={12}>
                        <GoogleAddressMap 
                            feature={mapFeature}
                            form={deliverySite}
                            fieldName="address"
                        />
                    </Grid>
                </FormRow>
                <FormRow>
                    <FormAutocompleteField
                        label="Zona"
                        form={deliverySite}
                        fieldName="zone"
                        options={zonesOptions}
                    />
                    <FormAutocompleteMultipleSelectField label={'Frecuencia excepcional'}
                                                         form={deliverySite}
                                                         fieldName="exceptionalFrequency"
                                                         options={frequenciesOptions}/>
                </FormRow>
                {zonesFrequencyString && <Typography>Frecuencia: {zonesFrequencyString}</Typography>}
            </FormColumn>
        </FormSection>
    );
}

export default observer(DeliverySiteOnboardingRequestFormScreen);
